import { WeekConsumptionStore } from './WeekConsumptionStore'
import { UserStore } from './UserStore'
import {
  IN_REP1,
  IN_REP2,
  IN_REP3,
  OUT_REP1,
  OUT_REP2,
  OUT_REP3,
  pourcentageBaro,
  calPerGlass,
  kBouchePhxLarx,
  kOesophage,
  kColonRectum,
  kFoie,
  kSein,
} from '../constants/results'

export interface IResultStore {
  cal: number
  depenses: number
  fa: boolean
  frequencyPerWeekStat: number
  hta: boolean
  isInConsumptionMarks: boolean
  kBouchePhxLarx: number
  kColonRectum: number
  kFoie: number
  kOesophage: number
  kSein: number
  overallConsumptionStat: number
  quantityPerDayStat: number
  quantityPerWeekStat: number
  avcHemo: boolean
  rep1: number
  rep2: number
  rep3: number
  toxCel: boolean
  calculateResults(): void
  reset(): void
}

export class ClassResultStore implements IResultStore {
  public cal = 0
  public depenses = 0
  public fa = false
  public frequencyPerWeekStat = 0
  public hta = false
  public isInConsumptionMarks = false
  public kBouchePhxLarx = 0
  public kColonRectum = 0
  public kFoie = 0
  public kOesophage = 0
  public kSein = 0
  public overallConsumptionStat = 0
  public quantityPerDayStat = 0
  public quantityPerWeekStat = 0
  public rep1 = 0
  public rep2 = 0
  public rep3 = 0
  public toxCel = false
  public avcHemo = false

  public reset(): void {
    this.cal = 0
    this.depenses = 0
    this.fa = false
    this.frequencyPerWeekStat = 0
    this.hta = false
    this.isInConsumptionMarks = false
    this.kBouchePhxLarx = 0
    this.kColonRectum = 0
    this.kFoie = 0
    this.kOesophage = 0
    this.kSein = 0
    this.overallConsumptionStat = 0
    this.quantityPerDayStat = 0
    this.quantityPerWeekStat = 0
    this.rep1 = 0
    this.rep2 = 0
    this.rep3 = 0
    this.toxCel = false
    this.avcHemo = false
  }

  public calculateResults(): void {
    this.generateReperes()
    this.getStatistics()
    this.getAdditionalStats()
  }

  private generateReperes(): void {
    this.rep1 = WeekConsumptionStore!.checkDayConsumptionForResults()
    this.rep2 = UserStore.consumptionDays.length > 5 ? 1 : 0
    this.rep3 = WeekConsumptionStore!.getGlassesNumberPerWeek() > 10 ? 1 : 0
  }

  private getRepsSum(): number {
    let sum = 0

    this.rep1 === 0 ? (sum += IN_REP1) : (sum += OUT_REP1)
    this.rep2 === 0 ? (sum += IN_REP2) : (sum += OUT_REP2)
    this.rep3 === 0 ? (sum += IN_REP3) : (sum += OUT_REP3)

    return sum
  }

  private findStatsDataBySexAndAge() {
    return pourcentageBaro.find((element) => {
      return (
        element.sex === UserStore.gender &&
        UserStore.age >= element.ageRange.min &&
        UserStore.age <= element.ageRange.max
      )
    })
  }

  private getStatistics(): void {
    const sum = this.getRepsSum()

    const mapping = {
      [IN_REP1]: 'quantityPerDayStat',
      [IN_REP2]: 'frequencyPerWeekStat',
      [IN_REP3]: 'quantityPerWeekStat',
      [OUT_REP1]: 'quantityPerDayStat',
      [OUT_REP2]: 'frequencyPerWeekStat',
      [OUT_REP3]: 'quantityPerWeekStat',
    }

    const data = this.findStatsDataBySexAndAge()

    if (data !== undefined) {
      Object.keys(mapping).forEach((key, index) => {
        const keyInt = parseInt(key, 10)
        if ((sum & keyInt) === keyInt) {
          this[mapping[keyInt]] = data[keyInt]
        }
      })

      if (sum === IN_REP1 + IN_REP2 + IN_REP3) {
        this.isInConsumptionMarks = true
        this.overallConsumptionStat = data[sum]
      } else {
        this.isInConsumptionMarks = false
        this.overallConsumptionStat = data[OUT_REP1 | OUT_REP2 | OUT_REP3]
      }
    }
  }

  private getAdditionalStats(): void {
    const glassesPerWeek = WeekConsumptionStore.getGlassesNumberPerWeek()

    this.cal = !this.isInConsumptionMarks ? calPerGlass[glassesPerWeek] : 0

    this.kBouchePhxLarx = !this.isInConsumptionMarks
      ? kBouchePhxLarx[glassesPerWeek]
      : 0

    this.kOesophage = !this.isInConsumptionMarks
      ? kOesophage[glassesPerWeek]
      : 0

    this.kColonRectum = !this.isInConsumptionMarks
      ? kColonRectum[glassesPerWeek]
      : 0

    this.kFoie = !this.isInConsumptionMarks ? kFoie[glassesPerWeek] : 0

    this.kSein =
      UserStore.gender === 'F' && !this.isInConsumptionMarks
        ? kSein[glassesPerWeek >= 100 ? 100 : glassesPerWeek]
        : 0

    this.avcHemo =
      (UserStore.gender === 'H' && !this.isInConsumptionMarks) ||
      (UserStore.gender === 'F' && glassesPerWeek >= 29)

    this.hta =
      (UserStore.gender === 'H' && !this.isInConsumptionMarks) ||
      (UserStore.gender === 'F' && glassesPerWeek >= 15)

    this.fa =
      (UserStore.gender === 'H' && !this.isInConsumptionMarks) ||
      (UserStore.gender === 'F' && glassesPerWeek >= 22)

    this.toxCel = !this.isInConsumptionMarks

    this.depenses = Math.floor(UserStore.price * (365.25 / 7))
  }
}

export const ResultStore = new ClassResultStore()



// WEBPACK FOOTER //
// ./src/store/ResultStore.ts